import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Textarea from 'common/components/elements/inputs/textarea';
// import { getCurrentPosition } from 'common/utils/utils';

const TextareaSection = ({
   value,
   name,
   limit,
   onChange,
   sectionName,
   ...props
}) => {
   const inputProps = props?.inputProps || {};
   let TextAreaRef = useRef(null);
   // const [cursorPosition, setCursorPosition] = useState(null);

   const updateTextareaHeight = () => {
      if(TextAreaRef?.current){
         if(TextAreaRef.current?.style && TextAreaRef.current?.scrollHeight) {
            TextAreaRef.current.style.height = TextAreaRef.current.scrollHeight + 2 + "px";
         }
         // setCursorPosition(getCurrentPosition(TextAreaRef))
      }
   }

   useEffect(() => {
      updateTextareaHeight();
   }, [TextAreaRef])

   return (
      <Textarea
         { ...inputProps }
         { ...props }
         value={ value }
         name={ `${ sectionName }_${ name }` }
         onChange={ (n, value) => {
            if(value.length > limit){
               return
            }
            updateTextareaHeight();
            onChange(name, value)
         } }
         description={ limit ? `${ value.length } of ${ limit } characters` : null }
         TextAreaRef={ TextAreaRef }
         minHeight='min-h-[94px]'
         isTextArea
         hideDescriptionWhenError
         height='auto'
      />
   )
}



TextareaSection.propTypes = {
   value: PropTypes.any,
   name: PropTypes.string,
   limit: PropTypes.number,
   onChange: PropTypes.func,
   inputProps: PropTypes.object,
   sectionName: PropTypes.string,
};
TextareaSection.defaultProps = {
   value: '',
   sectionName: '',
}

export default TextareaSection;
